import { IconFromSet } from '@gettactic/components';
import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { IconShape as IIconShape } from '../../../../types';
import { useShape } from '../ShapeContext/useShape';

export const IconShapeSVG: React.FC = () => {
  const { shape } = useShape();
  const iconShape = shape as IIconShape;

  // Generate the SVG string for the icon
  const svgString = <IconFromSet icon={iconShape.icon} color={iconShape.color} size={64} style={{width:shape.width, height:shape.height}} preserveAspectRatio={"none"} />;

  // Calculate the transform for the entire icon group
  const transform = `translate(${shape.x}, ${shape.y})${shape.rotation ? ` rotate(${shape.rotation})` : ''}`;

  // Calculate the scale factors based on the icon size (64) and desired shape size
  const scaleX = shape.width / 64;
  const scaleY = shape.height / 64;

  // Calculate text position and alignment
  const textX = (() => {
    if (iconShape.textAlign === 'center') {
      return shape.width / 2;
    } else if (iconShape.textAlign === 'right') {
      return shape.width;
    } else {
      return 0;
    }
  })();

  const textAnchor = iconShape.textAlign === 'center' ? 'middle' : iconShape.textAlign === 'right' ? 'end' : 'start';

  return (
    <g transform={transform}>
      {/* Render the icon SVG */}
      <g
        //transform={`scale(${scaleX}, ${scaleY})`}
      >{svgString}</g>
      
      {/* Render the text if present */}
      {iconShape.text && (
        <text
          x={textX}
          width={shape.width}
          y={iconShape.height + 10}
          fontSize={iconShape.fontSize || 16}
          fontFamily={iconShape.fontFamily || 'Arial'}
          fontWeight={iconShape.isBold ? 'bold' : 'normal'}
          fontStyle={iconShape.isItalic ? 'italic' : 'normal'}
          textDecoration={iconShape.isUnderline ? 'underline' : 'none'}
          fill={iconShape.textColor || '#000000'}
          textAnchor={textAnchor}
          dominantBaseline="hanging"
        >
          {iconShape.text}
        </text>
      )}
    </g>
  );
}; 